import { render } from "./BinaMarga.vue?vue&type=template&id=247f3214"
import script from "./BinaMarga.vue?vue&type=script&lang=js"
export * from "./BinaMarga.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__